import VerifyInSalesCreditNote from "../../../../components/@documents/sales_credit_notes/VerifyInSalesCreditNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesCreditNoteVerifyInPage() {

    return (
        <VerifyInSalesCreditNote 
            routeType={routeTypes.admin}
        />
    )
}